var minLength = function (length) {
    return function (value) { return ("" + value).length >= length; };
};

export { minLength };
